/**
 * This component renders a standings table
 */

import React from 'react';
import { Link } from 'react-router-dom';

const StandingsTable = ({division_id, table_data, extraClasses, expanded=false}) => {

    division_id = division_id || table_data.id || null;

    let footnote = 1;

    let standings_notes = [];
    table_data.stats.forEach(team => {
        if (team.penalties.length > 0) {
            team.penalties.forEach(penalty => {
                team.footnotes.add(footnote);
                standings_notes.push("[" + footnote + "] " + team.team_name + (penalty.ejected ? " removed from standings for repeated rules violation " : " penalised " + penalty.reduction + " point"+
                    (penalty.reduction > 1 ? "s" : "") +" for rules violation ") + "(" + penalty.code + ")");
                footnote += 1;
            })
        }
    });

    return (
        <div className={`w-full ${extraClasses}`}>
        <div className="dark:bg-dark-4 bg-light-2 w-full rounded py-1 w-full mb-2 xs:px-1 pt-1 xs:pb-4">
            <table className="table-auto w-full">
                <thead>
                <tr>
                    <th className="max-xs:text-xs pl-2 text-left pb-1 lg:b-2 min-w-6/12">
                    <Link to={`/division/${division_id}`} className="hover:text-buiha-red dark:hover:text-dark-5 ease-in-out duration-200 font-normal">
                    {table_data.title}
                    </Link>
                    </th>
                    <th className="max-xs:text-xs px-1 text-center pb-1 lg:b-2 font-normal">GP</th>
                    { !expanded && <th className="max-xs:text-xs px-1 w-16 text-center pb-1 lg:b-2 font-normal">Record</th> }

                    { table_data.nationals && <th className="w-12 px-1 text-center pb-1 lg:b-2 font-normal">PP*</th> }

                    { expanded && <th className="text-center px-1 pb-1 lg:b-2 font-normal">W</th> }
                    { expanded && <th className="text-center px-1 pb-1 lg:b-2 font-normal">L</th> }
                    { expanded && <th className="text-center px-1 pb-1 lg:b-2 font-normal">D</th> }

                    <th className="max-xs:text-xs text-center px-1 pb-1 lg:b-2 font-normal">GD</th>
                    <th className="max-xs:text-xs text-center px-1 pb-1 lg:b-2 font-normal">Pts</th>
                </tr>
                </thead>
                <tbody>
    {table_data.stats.map((team, index) => (
        <tr 
            key={index} 
            className={`
                ${index === 0 ? "table_green" : ""} 
                ${index === table_data.stats.length - 1 ? "table_red" : ""}
                ${index % 2 === 0 && index !== 0 && index !== table_data.stats.length - 1 ? "bg-light-1 dark:bg-dark-1" : "bg-light-2 dark:bg-dark-4"}
            `}
        >
            <td className={`w-full py-0.5 text-left max-xs:text-xs pl-1 ${team.team_class} flex-row flex justify-start items-center`}>
                <img className={`w-5 h-5 mr-2 ${team.team_class}`} src={team.logo} alt={team.team} />
                <Link to={`/club/${team.club}`} className="w-full">
                    <p className={`text-left ${team.team_class} hover:text-buiha-red dark:hover:text-dark-5 ease-in-out duration-200 font-light`}>
                        {team.team_name}{Array.from(team.footnotes).length > 0 && Array.from(team.footnotes).map((footnote) => (
                        <span className="align-super text-xxxs">[{footnote}]</span>))}
                    </p>
                </Link>
            </td>
            <td className={`p-0.5 md:px-1 text-center max-xs:text-xs leading-tight font-light ${team.team_class}`}>{team.games}</td>
            { !expanded && <td className={`p-0.5 md:px-1 text-center max-xs:text-xs leading-tight font-light ${team.team_class}`}>{team.record}</td> }

            { table_data.nationals && <td className={`p-0.5 md:px-1 text-center max-xs:text-xs leading-tight font-light ${team.team_class}`}>{team.pp}</td> }

            { expanded && <td className={`p-0.5 md:px-1 text-center max-xs:text-xs leading-tight font-light ${team.team_class}`}>{team.w}</td> }
            { expanded && <td className={`p-0.5 md:px-1 text-center max-xs:text-xs leading-tight font-light ${team.team_class}`}>{team.l}</td> }
            { expanded && <td className={`p-0.5 md:px-1 text-center max-xs:text-xs leading-tight font-light ${team.team_class}`}>{team.d}</td> }

            <td className={`p-0.5 md:px-1 text-center max-xs:text-xs leading-tight font-light ${team.team_class}`}>{team.gd}</td>
            <td className={`p-0.5 md:px-1 text-center max-xs:text-xs leading-tight font-light ${team.team_class}`}>{team.points}</td>
        </tr>
    ))}
</tbody>
            </table>
            <>{standings_notes.length > 0 && (<p className="pt-1 text-xxxs text-center mt-1">
                {standings_notes.map((note) => (<span className="block">{note}</span>)
                )}</p>)}</>
            { table_data.nationals && <p className="text-darken text-xxxs xs:text-xxs text-center mt-1 px-2">*PP = Penalty Points; 1x for 10m Misconduct, 2x for Game Misconduct, 3x for 5 + Game Misconduct, 5x for Match Penalty.</p> }
            {/* for DQ and point deductions etc */}
            { table_data.notes && <p className="text-xxxs text-center mt-1">{table_data.notes}</p> }
        </div>
        </div>
    );
}
export default StandingsTable;
